import { JournalForm } from "../../Components/JournalForm/JournalForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavBarContext } from "core/state/NavBarContext/NavBarContext";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";
import { Error404 } from "../../../../UIPalette/Error404/Error404";
import { parseDateToString } from "core/helpers/dates";

export const EditJournalEntry = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state: journalEntryData } = useLocation();
  const titleDate = parseDateToString(new Date(journalEntryData?.date ?? 0));

  useNavBarContext({ title: journalEntryData?.date ? titleDate : "" });

  const handleMainBack = () => navigate(-1);

  if (!journalEntryData) {
    return <Error404 message={t("positiveYou.entryNotFound")} fullscreen={false} />;
  }

  return (
    <>
      <PageTitle title={t("pageTitle.positiveYou.edit")} />
      <JournalForm handleMainBack={handleMainBack} initialValue={journalEntryData} />
    </>
  );
};
